import React, { memo, useMemo } from 'react';

import EntityFormModal from '@sharedCR/common/EntityFormModal';
import PropTypes from 'prop-types';

import EscrowDisbursementDrawerContent from './EscrowDisbursementDrawerContent';

const EscrowDisbursementDrawer = ({ isOpen, onClose, disbursement, applicationId, onSuccess }) => {
  const title = disbursement ? 'Edit Disbursement' : 'Record Disbursement';

  const additionalProps = useMemo(
    () => ({ disbursement, applicationId, onSuccess }),
    [disbursement, applicationId, onSuccess],
  );

  return (
    <EntityFormModal
      isData
      isHiddenNavigationTabs
      Content={EscrowDisbursementDrawerContent}
      additionalProps={additionalProps}
      isOpen={isOpen}
      title={title}
      onClose={onClose}
    />
  );
};

EscrowDisbursementDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  applicationId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  disbursement: PropTypes.object,
};

export default memo(EscrowDisbursementDrawer);
